"use strict";

class SContactUs extends HTMLElement {
  constructor() {
    super();

    this.validateForm = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const showError = (input, hasError) => {
        if (hasError) {
          input.closest("label").classList.add("is-error");
          isValid = false;
        } else {
          input.closest("label").classList.remove("is-error");
        }
      };

      let isValid = true;

      // Name validation — blocks all non-Latin/non-Cyrillic and non-space characters
      const nameInput = this.querySelector(".js-contact-us__input-name");
      showError(nameInput, !nameInput.value.trim() || /[^a-zA-Zа-яА-ЯёЁ\s]/.test(nameInput.value));

      // Email validation — blocks special characters like <>"'%;)(&+
      const emailInput = this.querySelector(".js-contact-us__input-email");
      showError(
        emailInput,
        !emailInput.value.trim() || !/^[^<>"'%;)(&+]+@[^<>"'%;)(&+]+\.[a-z]{2,}$/.test(emailInput.value)
      );

      // Message input — blocks common special characters
      const messageInput = this.querySelector(".js-contact-us__input-text");
      if (messageInput) {
        showError(messageInput, !messageInput.value.trim());
      }

      // Textarea — same restriction
      const textarea = this.querySelector(".s-contact-us__textarea");
      showError(textarea, !textarea.value.trim());

      // Submit if valid
      if (isValid && event.type === "submit") {
        this.form.submit();
      } else {
        this.form.addEventListener("input", this.validateForm);
      }
    };
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.validateForm);
    }
  }

  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener("submit", this.validateForm);
      this.form.removeEventListener("input", this.validateForm);
    }
  }
}

if (!customElements.get("s-contact-us")) {
  customElements.define("s-contact-us", SContactUs);
}
